import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/table/table-row.js'

const tagName = 'dap-ds-table-row'

/**
 * Table row component.
 * @element dap-ds-table-row
 * @title - Table row
 * @group table
 *
 * @slot - The default slot. Accepts `dap-ds-table-cell` and `dap-ds-table-header` elements.
 *
 * @cssprop --dds-table-row-padding-right - Padding right for the last table header, (default: var(--dds-spacing-500))
 * @cssprop --dds-table-row-padding-top - Padding top for table headers in mobile view, (default: var(--dds-spacing-400))
 * @cssprop --dds-table-row-padding-bottom - Padding bottom for the last table cell in mobile view, (default: var(--dds-spacing-400))
 * @cssprop --dds-table-row-border-color - Border color for table cells and headers, (default: transparent)
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSTableRow',
})

export default reactWrapper
